<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <app-reservation-select (reservationInfoEvent)="reservationInfoItem($event)" [title]="title" [reservationId]="reservationId"> </app-reservation-select>
          <span>
            <small class="p-invalid"
              *ngIf="isReservationId">Reservation is required
            </small>
          </span>
        </span>
      </div> -->

      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
          optionValue="value" placeholder="Status" [disabled]="true"></p-dropdown>
          <label for="Status">Status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="propertyCode" id="propertyCode" type="text" pInputText readonly="true">
          <label for="propertyCode">Property Code</label>
          @for (validation of validationMessages.propertyCode; track validation) {
            <span>
              @if (form1.get('propertyCode').hasError(validation.type) && (form1.get('propertyCode').dirty || form1.get('propertyCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="checkInDate" inputId="checkInDate" appendTo="body" [disabled]="true">
          </p-calendar>
          <label for="checkInDate">Check In Date</label>
          @for (validation of validationMessages.checkInDate; track validation) {
            <span>
              @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="checkOutDate" inputId="checkOutDate" appendTo="body" [disabled]="true">
          </p-calendar>
          <label for="checkOutDate">Check Out Date</label>
          @for (validation of validationMessages.checkOutDate; track validation) {
            <span>
              @if (form1.get('checkOutDate').hasError(validation.type) && (form1.get('checkOutDate').dirty || form1.get('checkOutDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="guestLastName" id="guestLastName" type="text" pInputText readonly="true">
          <label for="guestLastName">Guest LastName</label>
          @for (validation of validationMessages.guestLastName; track validation) {
            <span>
              @if (form1.get('guestLastName').hasError(validation.type) && (form1.get('guestLastName').dirty || form1.get('guestLastName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="enteredByUserId" id="username" type="text" pInputText readonly="true">
          <label for="title">Entered By</label>
        </span>
      </div>


      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="orderDetails" formControlName="payFromOrderDetailId" optionLabel="name"
            [filter]="true" filterBy="name"
            optionValue="orderDetailId" placeholder="Pay from invoice order product" [disabled]="isUpdate"
          (onChange)="onOrderDetailSelect($event)"></p-dropdown>
          <label for="Pay From Invoice Order Product" >Pay from invoice order product</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="ledgerItemTypes" formControlName="ledgerItemType" optionLabel="name"
          optionValue="value" placeholder="Ledger Item Type" [disabled]="true"></p-dropdown>
          <label for="Ledger Item Type">Ledger Item Type</label>
          @for (validation of validationMessages.ledgerItemType; track validation) {
            <span>
              @if (form1.get('ledgerItemType').hasError(validation.type) && (form1.get('ledgerItemType').dirty || form1.get('ledgerItemType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="orderProducts" formControlName="payFromOrderProductId" optionLabel="name"
            [filter]="true" filterBy="name"
            optionValue="orderProductId" placeholder="Pay From Order Product" [disabled]="isUpdate"
          ></p-dropdown>
          <label for="Select Order Product" >Pay From Order Product</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="orderProducts" formControlName="orderProductId" optionLabel="name"
            [filter]="true" filterBy="name"
            optionValue="orderProductId" placeholder="Pay To Order Product" [disabled]="isUpdate"
          (onChange)="onProductSelect($event)"></p-dropdown>
          <label for="Select Order Product" >Pay To Order Product</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <!--			<div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [options]="chartAccounts" formControlName="chartAccountId" optionLabel="actName"
        optionValue="chartAccountId" placeholder="Select Chart Account" [disabled]="true"></p-dropdown>
        <label for="Select Chart Account">Select Chart Account</label>
        <span *ngFor="let validation of validationMessages.status">
          <small class="p-invalid"
            *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>-->

    <!--reservation search -->

    <!-- <div class="p-field col-6" style="max-width:200px;">
    <button style="max-width:200px;" class="mr-3 p-button-outlined p-button-info" pButton
    type="button" label="Create From Reservation" (click)="onFindReservationClick()"></button>
  </div> -->

  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="title" id="title" type="text" pInputText readonly="{{disableTitle ? 'readonly': ''}}">
      <label for="title">Title</label>
      @for (validation of validationMessages.title; track validation) {
        <span>
          @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>




  <div class="col-lg-3">
    <span class="p-float-label required-field w-100 mb-3">
      <p-dropdown class="w-100" [options]="payToDetails" formControlName="payFrom" optionLabel="name"
      optionValue="value" placeholder="Pay From"></p-dropdown>
      <label for="Pay From">Pay From</label>
      @for (validation of validationMessages.payFrom; track validation) {
        <span>
          @if (form1.get('payFrom').hasError(validation.type) && (form1.get('payFrom').dirty || form1.get('payFrom').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-3">
    <span class="p-float-label required-field w-100 mb-3">
      <p-dropdown class="w-100" [options]="payToDetails" formControlName="payTo" optionLabel="name"
      optionValue="value" placeholder="Pay To"></p-dropdown>
      <label for="Pay To">Pay To</label>
      @for (validation of validationMessages.payTo; track validation) {
        <span>
          @if (form1.get('payTo').hasError(validation.type) && (form1.get('payTo').dirty || form1.get('payTo').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-3">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="quantity" id="quantity" type="number" pInputText>
      <label for="quantity">Quantity</label>
      @for (validation of validationMessages.quantity; track validation) {
        <span>
          @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-3">
    <span class="p-float-label required-field w-100 mb-3">
      <!-- <p-inputMask formControlName="listPrice" id="listPrice" mask="9.99"></p-inputMask> -->
      <p-inputNumber class="w-100 eap-input" formControlName="listPrice" id="listPrice" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="listPrice">List Price $</label>
      @for (validation of validationMessages.listPrice; track validation) {
        <span>
          @if (form1.get('listPrice').hasError(validation.type) && (form1.get('listPrice').dirty || form1.get('listPrice').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>




  <!--		<div class="col-lg-12">
  <span class="p-float-label required-field w-100 mb-3">
    <p-inputMask formControlName="listPriceAdjustmentPercent" id="listPriceAdjustmentPercent"
    mask="9.99"></p-inputMask>
    <label for="listPriceAdjustmentPercent">Discount %</label>
    <span *ngFor="let validation of validationMessages.listPriceAdjustmentPercent">
      <small class="p-invalid"
        *ngIf="form1.get('listPriceAdjustmentPercent').hasError(validation.type) && (form1.get('listPriceAdjustmentPercent').dirty || form1.get('listPriceAdjustmentPercent').touched)">{{validation.message}}
      </small>
    </span>
  </span>
</div>-->


<div class="col-lg-6">
  <span class="p-float-label w-100 mb-3">
    <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea readonly="{{isAllowedToUpdateOpsNotes ? '': 'readonly'}}"></textarea>
    <label for="opsNotes">Optional Notes</label>
    @for (validation of validationMessages.opsNotes; track validation) {
      <span>
        @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>

<div class="col-lg-6">
  <span class="p-float-label w-100 mb-3">
    <textarea formControlName="ownerNotes" id="ownerNotes" [rows]="2" pInputTextarea></textarea>
    <label for="ownerNotes">Owner Notes</label>
    @for (validation of validationMessages.ownerNotes; track validation) {
      <span>
        @if (form1.get('ownerNotes').hasError(validation.type) && (form1.get('ownerNotes').dirty || form1.get('ownerNotes').touched)) {
          <small class="p-invalid"
            >{{validation.message}}
          </small>
        }
      </span>
    }
  </span>
</div>


</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (reservationLedgerId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete ReservationLedger</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!reservationLedgerId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add ReservationLedger</button>
          }

          @if (reservationLedgerId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update ReservationLedger</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
